import {
  Badge
} from 'react-bootstrap';

export default function PText(props) {
  if (props.description === undefined) {
    return (
      <p className="mb-0">
        <b>{props.value}</b>
      </p>        
    )
  } else {
    return (
      <p className="mb-0">
        <b>{props.value}</b> <Badge bg="danger">{props.description}</Badge>
      </p>
    )
  }
}
